function validate_email(email) {
	var re = new RegExp('^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$');
	return re.test(email);
}
// https://www.tutorialspoint.com/regex-in-reactjs
export default validate_email;
